const wholeEuroFormatter = new Intl.NumberFormat('fr-FR', {
	style: 'currency',
	currency: 'EUR',
	maximumFractionDigits: 0,
});

/** An amount in whole euros, for limits ("900 €"). */
const formatWholeEuros = (amount: number): string => wholeEuroFormatter.format(amount);

export default formatWholeEuros;
